import React, { useState, useEffect } from 'react'
import Container from '@mui/material/Container'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { useParams } from 'react-router-dom'
import Grid from '@mui/material/Grid2'
import Card from '@mui/material/Card'
import { CardContent } from '@mui/material'
import Box from '@mui/material/Box'
import DownloadIcon from '@mui/icons-material/Download'
import Button from '@mui/material/Button'
import CardActions from '@mui/material/CardActions'
import ProtocolComDraw from './Weighing/Protocols/ProtocolComDraw'
import ErrorBoundary from '../ErrorBoundary'
import ProtocolSector from './Weighing/Protocols/ProtocolSector'
import ProtocolComSvod from './Weighing/Protocols/ProtocolComSvod'
import DocProtocolPair from './Weighing/Protocols/DocProtocolPair'
import DocProtocolPairStep from './Weighing/Protocols/DocProtocolPairStep'

import DocProtocolPairComandSvodGroup from './Weighing/Protocols/DocProtocolPairComandSvodGroup'
import DocProtocolPairComandGroup from './Weighing/Protocols/DocProtocolPairComandGroup'
import DocProtocolPairComand from './Weighing/Protocols/DocProtocolPairComand'
import DocProtocolWeighing from './Weighing/Protocols/DocProtocolWeighing'
import DocProtocolPairCount from './Weighing/Protocols/DocProtocolPairCount'
import DocProtocolPairCountWeight from './Weighing/Protocols/DocProtocolPairCountWeight'
import DocSummaryTournamentProtocol from './Weighing/Protocols/DocSummaryTournamentProtocol'

import { updateData, addRequestsData } from '../api/indexedDBHandler'
import { getData } from '../api/indexedDBHandler'
import { styled } from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import UpdateOnline from './Weighing/UpdateOnline'
import Confirmed from './Docs/Confirmed'
import TeamStatistics from './Docs/TeamStatistics'

const TournamentDocumentation = () => {
  const { id } = useParams()
  const [weighingDoc, setWeighingDoc] = useState(null)
  const [protocoStep, setProtocoStep] = useState(null)
  const [protocolWeight, setProtocolWeight] = useState(null)
  const [protocolWeightComand, setProtocolWeightComand] = useState(null)
  const [protocolWeightComandSvodGroup, setProtocolWeightComandSvodGroup] =
    useState(null)
  const [protocolWeightComandGroup, setProtocolWeightComandGroup] =
    useState(null)
  const [protocolPairCount, setProtocolPairCount] = useState(null)
  const [protocolPairProtocol5Big, setPairProtocol5Big] = useState(null)
  const [protocolPairProtocol1Big, setPairProtocol1Big] = useState(null)
  const [protocolPairProtocol3Big, setPairProtocol3Big] = useState(null)

  const [protocolSummary, setSummaryProtocol] = useState(null)
  const [pair, setPair] = useState(null)
  const [isProtocoStep, setIsProtocoStep] = useState(null)

  const [pairZona, setPairZona] = useState(null)

  const [isProtocollWeight, setIsProtocolWeight] = useState(null)
  const [isProtocolWeighingDoc, setIsProtocolWeighinDoc] = useState(null)
  const [isProtocolCounts, setisProtocolCounts] = useState(null)
  const [isProtocol5Big, setisProtocol5Big] = useState(null)
  const [isProtocol1Big, setisProtocol1Big] = useState(null)
  const [isProtocol3Big, setisProtocol3Big] = useState(null)
  const [isProtocolAll, setisProtocolAll] = useState(null)

  const [stage, setStage] = useState(null)
  const [stageAll, setStageAll] = useState(null)
  const [stageNull, setStageNull] = useState(null)

  const [visibleProtocolSvod, setVisibleProtocolSvod] = useState(false)
  const [visiblProtocolCounts, setVisibleProtocolCounts] = useState(false)
  const [visibleProtocol1Big, setVisibleProtocol1Big] = useState(false)
  const [visibleProtocol5Big, setVisibleProtocol5Big] = useState(false)
  const [visibleProtocolAll, setVisibleProtocolAll] = useState(false)

  const [confirmed, seСonfirmed] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [disabledGener, setdisableGener] = useState(true)

  const [tournament, setTournament] = useState(null)
  const [disable, setdisable] = useState(true)
  const [disableFinish, setdisableFinish] = useState(true)
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }))

  const generateProtocolsFinish = async () => {
    setIsLoading(true)
    if (pair && isProtocoStep) {
      console.log('DocProtocolPairStep')
      const value = await DocProtocolPairStep.generate(id, true)
      setProtocoStep(value.previewUrl.fileUrl)
      console.log('DocProtocolPairStep', value.previewUrl.fileUrl)
    }
    if (pair && isProtocollWeight) {
      console.log('DocProtocolPair')
      const value = await DocProtocolPair.generate(id, true)
      setProtocolWeight(value.previewUrl.fileUrl)
      console.log('DocProtocolPair', value.previewUrl.fileUrl)
    }

    setIsLoading(false)
  }

  const generateProtocols = async () => {
    setIsLoading(true)
    if (pair && isProtocollWeight && !pairZona) {
      console.log('DocProtocolPair')
      const value = await DocProtocolPair.generate(id)
      setProtocolWeight(value.previewUrl.fileUrl)
      console.log('DocProtocolPair', value.previewUrl.fileUrl)
    }
    if (pair && isProtocolCounts && !pairZona) {
      console.log('DocProtocolPairCount')
      const value = await DocProtocolPairCount.generate(id)
      setProtocolPairCount(value.previewUrl.fileUrl)
      console.log('DocProtocolPairCount', value)
    }
    if (pair && isProtocoStep && !pairZona) {
      console.log('DocProtocolPairStep')
      const value = await DocProtocolPairStep.generate(id, false)
      setProtocoStep(value.previewUrl.fileUrl)
      console.log('DocProtocolPairStep', value.previewUrl.fileUrl)
    }

    if (pair && isProtocol5Big && !pairZona) {
      console.log('isProtocol5Big')
      const minWeight = 1500
      const countFish = 5

      const value = await DocProtocolPairCountWeight.generate(
        id,
        minWeight,
        countFish
      )
      setPairProtocol5Big(value.previewUrl.fileUrl)
      console.log('isProtocol5Big', value)
    }

    if (pair && isProtocol3Big && !pairZona) {
      console.log('isProtocol3Big')
      const minWeight = 6000
      const countFish = 3

      const value = await DocProtocolPairCountWeight.generate(
        id,
        minWeight,
        countFish
      )
      setPairProtocol3Big(value.previewUrl.fileUrl)
      console.log('isProtocol3Big', value)
    }

    if (pair && isProtocol1Big && !pairZona) {
      console.log('isProtocol1Big')
      const minWeight = 1500
      const countFish = 1

      const value = await DocProtocolPairCountWeight.generate(
        id,
        minWeight,
        countFish
      )
      setPairProtocol1Big(value.previewUrl.fileUrl)
      console.log('isProtocol1Big', value)
    }

    if (pair && isProtocolAll && !pairZona) {
      console.log('isProtocolAll')

      const value = await DocSummaryTournamentProtocol.generate(id)
      setSummaryProtocol(value.previewUrl.fileUrl)
      console.log('isProtocolAll', value)
    }

    if (!pair && isProtocollWeight && !pairZona) {
      console.log('DocProtocolPairComandSvodGroup')

      const value = await DocProtocolPairComandSvodGroup.generate(id)
      setProtocolWeightComandSvodGroup(value.previewUrl.fileUrl)
      console.log('DocProtocolPairComandSvodGroup', value.previewUrl.fileUrl)

      const value2 = await DocProtocolPairComand.generate(id)
      setProtocolWeightComand(value2.previewUrl.fileUrl)
      console.log('DocProtocolPairComand', value2.previewUrl.fileUrl)

      const value3 = await DocProtocolPairComandGroup.generate(id)
      setProtocolWeightComandGroup(value3.previewUrl.fileUrl)
      console.log('DocProtocolPairComand', value3.previewUrl.fileUrl)
    }
    if (pairZona) {
      const value2 = await DocProtocolPairComand.generate(id)
      setProtocolWeightComand(value2.previewUrl.fileUrl)
      console.log('DocProtocolPairComand', value2.previewUrl.fileUrl)

      const value = await DocProtocolPairComandSvodGroup.generate(id)
      setProtocolWeightComandSvodGroup(value.previewUrl.fileUrl)
      console.log('DocProtocolPairComandSvodGroup', value.previewUrl.fileUrl)
    }

    const weighing = await DocProtocolWeighing.generate(id)

    setWeighingDoc(weighing.previewUrl.fileUrl)
    setIsLoading(false)
  }

  const downloadFile = (doc, filename) => {
    const link = document.createElement('a')
    link.href = URL.createObjectURL(doc.blob)
    link.download = filename
    link.click()

    //   const a = document.createElement('a')
    //   a.href = url
    //   a.download = `парный_протокол_${dateNowProtocol(new Date())}.pdf`
    //   document.body.appendChild(a)
    //   a.click()
    //   document.body.removeChild(a)
  }

  const publishFile = (doc, name) => {
    // Пустая функция, просто логгируем ссылку (можно подставить реальную публикацию позже)
    alert(`Опубликован ${name} (ссылка в консоли)`)
  }

  useEffect(() => {
    const gettournaments = async () => {
      const resultsT = await getData('tournaments', 'id', id)
      if (resultsT.length > 0) {
        const { value } = resultsT[0]
        console.log('value', value)
        if (value.competition_format === 'Парные соревнования') setPair(true)
        else if (value.competition_format === 'Парные соревнования (по зонам)')
          setPairZona(true)
        else setPair(false)

        if (value.current_count_cup > 1) setIsProtocoStep(true)
        else setIsProtocoStep(false)

        if (value.winners.includes('По общему весу')) {
          setIsProtocolWeight(true)
        }
        if (value.winners.includes('По количеству рыб')) {
          setisProtocolCounts(true)
        }
        if (value.winners.includes('По 5 самым крыпным рыбам')) {
          setisProtocol5Big(true)
        }
        if (value.winners.includes('По 3 самым крыпным рыбам')) {
          setisProtocol3Big(true)
        }

        if (value.winners.includes('По 1 самой крыпной рыбе')) {
          setisProtocol1Big(true)
        }
        if (value.protocols === 'Дополнительный общий протокол победителя') {
          setisProtocolAll(true)
        }

        setTournament(value)
      }
    }
    gettournaments()
  }, [id])
  useEffect(() => {}, [stage])
  const responseTournaments = (response) => {
    setdisableGener(false)

    setTournament(response)
  }
  const responseStage = (response) => {
    setdisableGener(false)

    updateData('stage', id, response.items)

    const hasNullConfirmed = response.some((item) => item.confirmed === null)

    seСonfirmed(!hasNullConfirmed)

    const nullConfirmedItems = response.filter(
      (item) => item.confirmed === null
    )

    setStageNull(nullConfirmedItems)
    // Пример использования:
    const result = sumWeightsAndCountFishByTeam(response)
    setStageAll(result)

    setStage(response.items)
  }

  const sumWeightsAndCountFishByTeam = (response) => {
    const teamStats = {} // { teamId: { totalWeight: число, fishCount: число }, ... }

    response.forEach((item) => {
      const { teamId, fishList, sector, teamName } = item

      // Считаем сумму весов и количество рыб с weight > 0 для текущего элемента
      const { sum, count } = fishList.reduce(
        (acc, fish) => {
          if (fish.weight > 0) {
            acc.sum += fish.weight
            acc.count += 1
          }
          return acc
        },
        { sum: 0, count: 0 }
      )

      // Обновляем общую статистику по teamId
      if (!teamStats[teamId]) {
        teamStats[teamId] = {
          totalWeight: 0,
          fishCount: 0,
          sector: sector,
          teamName: teamName,
        }
      }
      teamStats[teamId].totalWeight += sum
      teamStats[teamId].fishCount += count
    })

    // Преобразуем в массив объектов { teamId, totalWeight, fishCount }
    return Object.entries(teamStats).map(([teamId, stats]) => ({
      teamId,
      ...stats, // totalWeight и fishCount
    }))
  }

  const responseTeams = (response) => {
    setdisableGener(false)

    // const teamsArray = Object.values(response)
    // const filteredTeams = teamsArray.filter((teamEntry) => {
    //   const isValidTeam =
    //     teamEntry !== null &&
    //     typeof teamEntry === 'object' &&
    //     teamEntry.team?.status === 'Заявка одобрена' &&
    //     teamEntry.team?.status_location === 1

    //   return isValidTeam
    // })
    // setTeams(filteredTeams)
  }

  // const isProtocolSvodCallback = (param) => {
  //   setIsProtocolWeight(param)
  // }

  const responseConf = (e) => {
    setProtocolWeight(null)
    setWeighingDoc(null)
    setStageNull(e)
  }
  const isProtocolWeighinfdCallback = (param) => {
    setIsProtocolWeighinDoc(param)
  }

  const postProtocolFinish = async () => {
    const resultsuser = await getData('user', 'created', true)
    const { key, value } = resultsuser[0]
    const user = value.phone
    let code = ''
    if (pair) {
      if (isProtocollWeight && protocoStep) {
        code = protocolWeight + ',' + protocoStep
      }
    }

    const update_data = {
      code,
      cup_id: id,
      user,
      requestKey: `${id}_${code}`,
    }
    try {
      await addRequestsData('requests', {
        url: 'protocol/sendP.php',
        ...update_data,
      })
    } catch (error) {}

    setIsProtocolWeight(null)
    setIsProtocolWeighinDoc(null)
    setProtocoStep(null)
    setProtocolWeightComand(null)
    setProtocolWeightComandSvodGroup(null)
    setProtocolWeightComandGroup(null)

    setProtocolPairCount(null)
    setPairProtocol1Big(null)
    setPairProtocol3Big(null)
    setPairProtocol5Big(null)
    setSummaryProtocol(null)

    setProtocolWeight(null)
    setWeighingDoc(null)
    setdisable(true)
    setdisableFinish(true)
  }

  const postProtocol = async () => {
    const resultsuser = await getData('user', 'created', true)
    const { key, value } = resultsuser[0]
    const user = value.phone
    let code = ''
    console.log('pair', pair)
    console.log('isProtocollWeight', isProtocollWeight)
    console.log('isProtocoStep', isProtocoStep)
    console.log('isProtocolCounts', isProtocolCounts)
    console.log('isProtocol5Big', isProtocol5Big)
    console.log('isProtocol3Big', isProtocol3Big)

    console.log('isProtocol1Big', isProtocol1Big)
    console.log('isProtocolAll', isProtocolAll)
    if (pair) {
      if (isProtocollWeight && isProtocoStep) {
        code = protocolWeight + ',' + protocoStep + ',' + weighingDoc
      } else if (isProtocollWeight && isProtocol5Big) {
        code =
          protocolWeight + ',' + protocolPairProtocol5Big + ',' + weighingDoc
      } else if (isProtocollWeight) {
        code = protocolWeight + ',' + weighingDoc
      }

      if (isProtocolCounts && isProtocol5Big && isProtocol1Big && isProtocolAll)
        code =
          protocolSummary +
          ',' +
          protocolPairCount +
          ',' +
          protocolPairProtocol1Big +
          ',' +
          protocolPairProtocol5Big +
          ',' +
          weighingDoc
      else if (isProtocolCounts && isProtocol5Big && isProtocol1Big)
        code =
          protocolPairCount +
          ',' +
          protocolPairProtocol1Big +
          ',' +
          protocolPairProtocol5Big +
          ',' +
          weighingDoc
      else if (isProtocollWeight && isProtocol5Big && isProtocol1Big)
        code =
          protocolWeight +
          ',' +
          protocolPairProtocol1Big +
          ',' +
          protocolPairProtocol5Big +
          ',' +
          weighingDoc
    } else if (isProtocol3Big) {
      code = protocolPairProtocol3Big + ',' + weighingDoc
    } else if (pairZona) {
      code =
        protocolWeightComand +
        ',' +
        protocolWeightComandSvodGroup +
        ',' +
        weighingDoc
    } else {
      if (isProtocollWeight) {
        code =
          protocolWeightComand +
          ',' +
          protocolWeightComandSvodGroup +
          ',' +
          protocolWeightComandGroup +
          ',' +
          weighingDoc
      }
    }

    const update_data = {
      code,
      cup_id: id,
      user,
      requestKey: `${id}_${code}`,
    }
    console.log('code', code)
    try {
      await addRequestsData('requests', {
        url: 'protocol/sendP.php',
        ...update_data,
      })
    } catch (error) {}

    setIsProtocolWeight(null)
    setIsProtocolWeighinDoc(null)
    setProtocoStep(null)
    setProtocolWeightComand(null)
    setProtocolWeightComandSvodGroup(null)
    setProtocolWeightComandGroup(null)

    setProtocolPairCount(null)
    setPairProtocol1Big(null)
    setPairProtocol5Big(null)
    setSummaryProtocol(null)

    setProtocolWeight(null)
    setWeighingDoc(null)
    setdisable(true)
    setdisableFinish(true)
  }

  //const [svodDoc, ] = useState(null)
  // const [weighingDoc, ] = useState(null)
  useEffect(() => {
    if (pair) {
      if (isProtocollWeight && isProtocoStep) {
        if (protocolWeight != null && protocoStep != null)
          setdisableFinish(false)
        else setdisableFinish(true)
      }

      if (isProtocollWeight) {
        if (protocolWeight != null && weighingDoc != null) setdisable(false)
        else setdisable(true)
      } else {
        let is = true
        console.log('is', is)
        if (isProtocol1Big) if (protocolPairProtocol1Big != null) is = false
        if (isProtocol5Big) if (protocolPairProtocol5Big != null) is = false
        if (isProtocol3Big) if (protocolPairProtocol3Big != null) is = false
        if (isProtocolAll) if (protocolSummary != null) is = false
        if (isProtocolCounts) if (protocolPairCount != null) is = false
        console.log('is', is)
        setdisable(is)
      }
    } else if (pairZona) {
      if (protocolWeightComand != null && protocolWeightComandSvodGroup != null)
        setdisable(false)
      else setdisable(true)
    } else {
      if (isProtocollWeight) {
        if (
          protocolWeightComand != null &&
          protocolWeightComandSvodGroup != null &&
          protocolWeightComandGroup != null
        )
          setdisable(false)
        else setdisable(true)
      }
    }
  }, [
    protocolWeight,
    weighingDoc,
    protocolWeightComand,
    protocolWeightComandSvodGroup,
    protocolWeightComandGroup,
    protocolPairCount,
    protocolPairProtocol5Big,
    protocolPairProtocol1Big,
    protocolPairProtocol3Big,
    protocolSummary,
    protocoStep,
  ])
  const genProtocolFinish = () => {
    return (
      <Box>
        <Button
          variant="contained"
          size="small"
          onClick={generateProtocolsFinish}
          sx={{ mt: 1, mb: 2 }}
          disabled={isLoading || disabledGener}
        >
          {isLoading ? 'Формирование...' : 'Сгенерировать протоколы'}
        </Button>

        <Grid container spacing={2}>
          {pair && isProtocollWeight && protocolWeight && (
            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Парный протокол
                </Typography>

                <Box
                  sx={{
                    width: 120,
                    height: 160,
                    border: 'none',
                    borderColor: 'none',
                  }}
                >
                  <iframe
                    src={protocolWeight}
                    width="120"
                    height="160"
                    style={{ border: 'none' }}
                    title="Сводный протокол"
                  />
                </Box>

                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                  <a
                    href={protocolWeight}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Открыть
                  </a>
                </Typography>
              </Paper>
            </Grid>
          )}
          {pair && isProtocoStep && protocoStep && (
            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Протокол этапов
                </Typography>

                <Box
                  sx={{
                    width: 120,
                    height: 160,
                    border: 'none',
                    borderColor: 'none',
                  }}
                >
                  <iframe
                    src={protocoStep}
                    width="120"
                    height="160"
                    style={{ border: 'none' }}
                    title="Сводный протокол"
                  />
                </Box>

                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                  <a
                    href={protocoStep}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Открыть
                  </a>
                </Typography>
              </Paper>
            </Grid>
          )}
        </Grid>
      </Box>
    )
  }
  const genProtocol = () => {
    return (
      <Box>
        <Button
          variant="contained"
          size="small"
          onClick={generateProtocols}
          sx={{ mt: 1, mb: 2 }}
          disabled={isLoading || disabledGener}
        >
          {isLoading ? 'Формирование...' : 'Сгенерировать протоколы'}
        </Button>

        <Grid container spacing={2}>
          {pair && isProtocollWeight && protocolWeight && (
            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Парный протокол
                </Typography>

                <Box
                  sx={{
                    width: 120,
                    height: 160,
                    border: 'none',
                    borderColor: 'none',
                  }}
                >
                  <iframe
                    src={protocolWeight}
                    width="120"
                    height="160"
                    style={{ border: 'none' }}
                    title="Сводный протокол"
                  />
                </Box>

                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                  <a
                    href={protocolWeight}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Открыть
                  </a>
                </Typography>
              </Paper>
            </Grid>
          )}
          {pair && isProtocoStep && protocoStep && (
            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Сумма этапов
                </Typography>

                <Box
                  sx={{
                    width: 120,
                    height: 160,
                    border: 'none',
                    borderColor: 'none',
                  }}
                >
                  <iframe
                    src={protocoStep}
                    width="120"
                    height="160"
                    style={{ border: 'none' }}
                    title="Сводный протокол"
                  />
                </Box>

                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                  <a
                    href={protocoStep}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Открыть
                  </a>
                </Typography>
              </Paper>
            </Grid>
          )}
          {!pair && isProtocollWeight && protocolWeightComand && (
            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  парный протокол
                </Typography>

                <Box
                  sx={{
                    width: 120,
                    height: 160,
                    border: 'none',
                    borderColor: 'none',
                  }}
                >
                  <iframe
                    src={protocolWeightComand}
                    width="120"
                    height="160"
                    style={{ border: 'none' }}
                    title="Сводный протокол"
                  />
                </Box>

                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                  <a
                    href={protocolWeightComand}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Открыть
                  </a>
                </Typography>
              </Paper>
            </Grid>
          )}
          {!pair && isProtocollWeight && protocolWeightComandGroup && (
            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  групповой
                </Typography>

                <Box
                  sx={{
                    width: 120,
                    height: 160,
                    border: 'none',
                    borderColor: 'none',
                  }}
                >
                  <iframe
                    src={protocolWeightComandGroup}
                    width="120"
                    height="160"
                    style={{ border: 'none' }}
                    title="Сводный протокол"
                  />
                </Box>

                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                  <a
                    href={protocolWeightComandGroup}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Открыть
                  </a>
                </Typography>
              </Paper>
            </Grid>
          )}
          {!pair && isProtocollWeight && protocolWeightComandSvodGroup && (
            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  сводный по группам
                </Typography>

                <Box
                  sx={{
                    width: 120,
                    height: 160,
                    border: 'none',
                    borderColor: 'none',
                  }}
                >
                  <iframe
                    src={protocolWeightComandSvodGroup}
                    width="120"
                    height="160"
                    style={{ border: 'none' }}
                    title="Сводный протокол"
                  />
                </Box>

                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                  <a
                    href={protocolWeightComandSvodGroup}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Открыть
                  </a>
                </Typography>
              </Paper>
            </Grid>
          )}
          {pair && protocolPairCount && (
            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  по количеству
                </Typography>

                <Box
                  sx={{
                    width: 120,
                    height: 160,
                    border: 'none',
                    borderColor: 'none',
                  }}
                >
                  <iframe
                    src={protocolPairCount}
                    width="120"
                    height="160"
                    style={{ border: 'none' }}
                    title="По количеству"
                  />
                </Box>

                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                  <a
                    href={protocolPairCount}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Открыть
                  </a>
                </Typography>
              </Paper>
            </Grid>
          )}
          {pair && protocolPairProtocol5Big && (
            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  по 5 рыбам
                </Typography>

                <Box
                  sx={{
                    width: 120,
                    height: 160,
                    border: 'none',
                    borderColor: 'none',
                  }}
                >
                  <iframe
                    src={protocolPairProtocol5Big}
                    width="120"
                    height="160"
                    style={{ border: 'none' }}
                    title="По количеству"
                  />
                </Box>

                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                  <a
                    href={protocolPairProtocol5Big}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Открыть
                  </a>
                </Typography>
              </Paper>
            </Grid>
          )}
          {pair && protocolPairProtocol3Big && (
            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  по 3 рыбам
                </Typography>

                <Box
                  sx={{
                    width: 120,
                    height: 160,
                    border: 'none',
                    borderColor: 'none',
                  }}
                >
                  <iframe
                    src={protocolPairProtocol3Big}
                    width="120"
                    height="160"
                    style={{ border: 'none' }}
                    title="По количеству"
                  />
                </Box>

                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                  <a
                    href={protocolPairProtocol3Big}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Открыть
                  </a>
                </Typography>
              </Paper>
            </Grid>
          )}
          {pair && protocolPairProtocol1Big && (
            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  по БигФишу
                </Typography>

                <Box
                  sx={{
                    width: 120,
                    height: 160,
                    border: 'none',
                    borderColor: 'none',
                  }}
                >
                  <iframe
                    src={protocolPairProtocol1Big}
                    width="120"
                    height="160"
                    style={{ border: 'none' }}
                    title="По количеству"
                  />
                </Box>

                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                  <a
                    href={protocolPairProtocol1Big}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Открыть
                  </a>
                </Typography>
              </Paper>
            </Grid>
          )}{' '}
          {pair && protocolSummary && (
            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  сводный
                </Typography>

                <Box
                  sx={{
                    width: 120,
                    height: 160,
                    border: 'none',
                    borderColor: 'none',
                  }}
                >
                  <iframe
                    src={protocolSummary}
                    width="120"
                    height="160"
                    style={{ border: 'none' }}
                    title="По количеству"
                  />
                </Box>

                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                  <a
                    href={protocolSummary}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Открыть
                  </a>
                </Typography>
              </Paper>
            </Grid>
          )}
          {weighingDoc && (
            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  взвешивание
                </Typography>

                <Box
                  sx={{
                    width: 120,
                    height: 160,
                    border: 'none',
                    borderColor: 'none',
                  }}
                >
                  <iframe
                    src={weighingDoc}
                    width="120"
                    height="160"
                    style={{ border: 'none' }}
                    title="Протокол взвешивания"
                  />
                </Box>

                <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                  <a
                    href={weighingDoc}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Открыть
                  </a>
                </Typography>
              </Paper>
            </Grid>
          )}
        </Grid>
      </Box>
    )
  }
  const handleDownloadFilledProtocol = () => {
    // Логика генерации/скачивания заполненного протокола
    // Пример:
    // window.open(`/api/protocols/filled?tournamentId=${currentTournamentId}`, '_blank');
  }

  // И состояние для проверки готовности протокола
  const url_back = '/tournaments/' + id
  //  visibleProtocol5Big visibleProtocol1Big
  //  visibleProtocolAll
  if (tournament)
    return (
      <Container sx={{ mb: 15 }}>
        <div role="presentation" style={{ textAlign: 'left', width: '100%' }}>
          <Breadcrumbs maxItems={2} aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/tournaments-list">
              Турниры
            </Link>
            <Link underline="hover" color="inherit" href={url_back}>
              Редактирование
            </Link>
            <Typography sx={{ color: 'text.primary' }}>Документация</Typography>
          </Breadcrumbs>
        </div>

        <Grid
          container
          spacing={1}
          sx={{
            width: '100%',
          }}
        >
          <Grid key="wwqwq7" size={{ xs: 12, md: 12 }}>
            <Item>
              <UpdateOnline
                id={id}
                responseTournaments={responseTournaments}
                responseTeams={responseTeams}
                responseStage={responseStage}
              />
            </Item>
          </Grid>
          <Grid
            key="wwqwq8"
            mt={2}
            md={3}
            sx={{
              width: '100%',
            }}
          >
            <Card>
              <CardContent sx={{ margin: 1 }}>
                <Typography variant="body1" sx={{ marginBottom: 2 }}>
                  Результаты взвешивания
                </Typography>
                <Confirmed
                  stage={stageNull}
                  all={stageAll}
                  func={responseConf}
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid
            key="wwqwq9"
            mt={2}
            md={3}
            sx={{
              width: '100%',
            }}
          >
            <Card>
              <CardContent sx={{ margin: 1 }}>
                <Typography variant="body1" sx={{ marginBottom: 2 }}>
                  Итоговая статистика по секторам
                </Typography>
                <TeamStatistics stage={stageNull} />
              </CardContent>
            </Card>
          </Grid>
          <Grid
            key="wwqwq5"
            mt={2}
            md={3}
            sx={{
              width: '100%',
            }}
          >
            <Card>
              <CardContent>
                <Typography variant="body1">Протоколы</Typography>

                <Grid container>
                  <Grid item size={{ xs: 12, md: 12 }}>
                    {genProtocol()}
                  </Grid>

                  {/*       {visibleProtocolSvod ? (
                    <Grid item xs={12}>
                      <Typography variant="body2" color="text.secondary">
                        Парный протокол (двойным нажатием)
                      </Typography>
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          sx={{ display: 'flex', justifyContent: 'flex-end' }}
                        >
                          <ErrorBoundary>
                             <DocProtocolPair
                              isProtocolSvodCallback={isProtocolSvodCallback}
                            />  
                          </ErrorBoundary>
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : (
                    <></>
                  )}
                  {visiblProtocolCounts ? (
                    <Grid item xs={12}>
                      <Typography variant="body2" color="text.secondary">
                        Протокол по количеству (двойным нажатием)
                      </Typography>
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          sx={{ display: 'flex', justifyContent: 'flex-end' }}
                        >
                          <ErrorBoundary>
                             <ProtocolSvod
                              isProtocolSvodCallback={isProtocolSvodCallback}
                            />  
                          </ErrorBoundary>
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : (
                    <></>
                  )}

                  {tournament.competition_format == 'Парные соревнования' ? (
                    <></>
                  ) : (
                    <>
                      <Grid item xs={12} sx={{ paddingTop: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                          Командный протокол (двойным нажатием)
                        </Typography>
                        <Grid container>
                          <Grid
                            item
                            xs={12}
                            sx={{ display: 'flex', justifyContent: 'flex-end' }}
                          >
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => handleDownloadFilledProtocol()}
                              sx={{ mt: 1 }}
                            >
                              ммм
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  )}
                  {tournament.competition_format == 'Парные соревнования' ? (
                    <></>
                  ) : (
                    <>
                      <Grid item xs={12} sx={{ paddingTop: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                          Сводный по группам (двойным нажатием)
                        </Typography>
                        <Grid container>
                          <Grid
                            item
                            xs={12}
                            sx={{ display: 'flex', justifyContent: 'flex-end' }}
                          >
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => handleDownloadFilledProtocol()}
                              sx={{ mt: 1 }}
                            >
                              ммм
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12} sx={{ paddingTop: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Проткол взвешивания (двойным нажатием)
                    </Typography>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sx={{ display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <ErrorBoundary>
                          <ProtocolComWeighing
                            isProtocolWeighinfdCallback={
                              isProtocolWeighinfdCallback
                            }
                          />
                        </ErrorBoundary>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ paddingTop: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Карта взвешивания (двойным нажатием)
                    </Typography>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sx={{ display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <Button
                          variant="contained"
                          size="small"
                          disabled={true}
                          onClick={() => handleDownloadFilledProtocol()}
                          sx={{ mt: 1 }}
                        >
                          в разработке
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid> */}
                  <Grid item size={{ xs: 12, md: 12 }} sx={{ pt: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Сначала проверьте все протоколы
                    </Typography>

                    <Button
                      variant="contained"
                      size="small"
                      color="success"
                      disabled={disable}
                      onClick={() => postProtocol()}
                      sx={{ mt: 1 }}
                    >
                      Опубликовать
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid
            key="wwqwq4"
            mt={2}
            md={3}
            sx={{
              width: '100%',
            }}
          >
            <Card>
              <CardContent sx={{ margin: 1 }}>
                <Typography variant="body1" sx={{ marginBottom: 2 }}>
                  Сектора
                </Typography>

                <Grid container spacing={2} sx={{ display: 'block' }}>
                  <Grid item xs={12}>
                    <Typography variant="body2" color="text.secondary">
                      Бланк протокола взвешивания сеткора (можно выбрать сектор
                      и стартовый номер)
                    </Typography>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sx={{ display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <ErrorBoundary>
                          <ProtocolSector />
                        </ErrorBoundary>

                        {/* <Button
                        variant="contained"
                        size="small"
                        onClick={() => handleDownloadEmptyProtocol()}
                        sx={{ mt: 1 }}
                      >
                        Выбрать сектор
                      </Button> */}
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sx={{ paddingTop: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Комплект протколов (полный стартовый комплект по 2 копии
                      на сектор)
                    </Typography>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sx={{ display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <Button
                          variant="contained"
                          size="small"
                          disabled={true}
                          sx={{ mt: 1 }}
                        >
                          в разработке
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid
            key="wwqwq346"
            mt={2}
            md={3}
            sx={{
              width: '100%',
            }}
          >
            <Card>
              <CardContent>
                <Typography variant="body1">Итоговые протоколы</Typography>

                <Grid container>
                  <Grid item size={{ xs: 12, md: 12 }}>
                    {genProtocolFinish()}
                  </Grid>

                  <Grid item size={{ xs: 12, md: 12 }} sx={{ pt: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Сначала проверьте все протоколы
                    </Typography>

                    <Button
                      variant="contained"
                      size="small"
                      color="success"
                      disabled={disableFinish}
                      onClick={() => postProtocolFinish()}
                      sx={{ mt: 1 }}
                    >
                      Опубликовать
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid
            key="wwqwq1"
            mt={2}
            md={3}
            sx={{
              width: '100%',
            }}
          >
            <Card>
              <CardContent sx={{ margin: 1 }}>
                <Typography variant="body1" sx={{ marginBottom: 2 }}>
                  Жеребьёвка
                </Typography>

                <Grid container spacing={2} sx={{ display: 'block' }}>
                  <Grid item xs={12}>
                    <Typography variant="body2" color="text.secondary">
                      Бланк протокола жеребьевки (с названиями команд, но без
                      секторов - для печати)
                    </Typography>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sx={{ display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <ErrorBoundary>
                          <ProtocolComDraw isBlank={true} />
                        </ErrorBoundary>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sx={{ paddingTop: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Заполненный протокол жеребьевки (двойным нажатием)
                    </Typography>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sx={{ display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <ErrorBoundary>
                          <ProtocolComDraw isBlank={false} />
                        </ErrorBoundary>
                        {/* <Button
                        variant="contained"
                        size="small"
                        onClick={() => handleDownloadFilledProtocol()}
                        sx={{ mt: 1 }}
                      >
                        Скачать
                      </Button> 
                      
                      
                      */}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid
            key="wwqwq2"
            mt={2}
            xs={12}
            sm={12}
            md={3}
            sx={{
              width: '100%',
            }}
          >
            <Card>
              <CardContent sx={{ margin: 1 }}>
                <Typography variant="body1">
                  Судейская документация ( в разработке )
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    )
}

export default TournamentDocumentation
